module.exports = __webpack_public_path__ + "static/007-b4ac9f9f84f108f9dcfa25b53e2c4d80.jpg";